// -- SET
// Replace : https://www.npmjs.com/package/lodash.set
export function set(obj, path, value) {
  const keys = path.split('.');
  let current = obj;

  keys.slice(0, -1).forEach(key => {
    if (!current[key]) {
      current[key] = {};
    }

    current = current[key];
  });

  current[keys[keys.length - 1]] = value;
}

// -- UNIQBY
// Replace : https://www.npmjs.com/package/lodash.uniqBy
export function uniqBy(array, key) {
  const seen = new Map();

  return array.filter(item => {
    const value = item[key];

    return seen.has(value) ? false : seen.set(value, true);
  });
}

// -- ISEQUAL
// Replace : https://www.npmjs.com/package/lodash.isequal
export function isEqual(a, b) {
  if (a === b) return true;

  if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
    return false;
  }

  const aKeys = Object.keys(a);
  const bKeys = Object.keys(b);

  if (aKeys.length !== bKeys.length) return false;

  for (let key of aKeys) {
    if (!bKeys.includes(key) || !isEqual(a[key], b[key])) {
      return false;
    }
  }

  return true;
}

// -- ISEMPTY
// Replace : https://www.npmjs.com/package/lodash.isempty
export function isEmpty(value) {
  if (value == null) return true;

  if (Array.isArray(value) || typeof value === 'string') {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    return Object.keys(value).length === 0;
  }
  
  return false;
}

// -- CLONE
// Replace : https://www.npmjs.com/package/lodash.clone
export function clone(value) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    return value.map(clone);
  }

  if (typeof value === 'object') {
    const result = {};

    Object.keys(value).forEach((key) => {
      result[key] = clone(value[key]);
    });

    return result;
  }

  return value;
}

// -- DEBOUNCE
// Replace : https://www.npmjs.com/package/lodash.debounce
export function debounce(func, wait) {
  let timeout;

  return function(...args) {
    const context = this;

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}
